import React, { useState, useEffect, useRef } from 'react';
import FeatherIcon from 'feather-icons-react';
import { useDispatch } from 'react-redux';
import { Row, Col, Form, Input, Select, message, Spin, Modal } from 'antd';
import PropTypes from 'prop-types';
// import { Scrollbars } from 'react-custom-scrollbars';
import { AddUser } from '../style';
import { setUserData } from '../../../redux/CrmReduxCalls/LocalDataReduxStore';
import { getStateData, getCityData, getCountryData, getTimeZoneData } from '../../../Api/Services/CommonApiService'
import { getByUserProfile, updateUserProfile } from '../../../Api/Services/UserApiService';
import { getCompanyByUser, CompanyUpdate } from '../../../Api/Services/CompanyApiService';
import { forecastCalculation } from '../../../Api/Services/ForcastApiService';
import { BasicFormWrapper, VerticalFormStyleWrap } from '../../styled';
import Heading from '../../../components/heading/heading';
import { Button } from '../../../components/buttons/buttons';
import DaysJson from '../MassupdateJson/Days.json'
import { validateUrlField, validateAddressLine, validateZipCode, nameOnChangeValidator, regNumOnChangeValidator } from '../../../components/utilities/utilities'; // validateDescriptionField

const { Option } = Select;

function UserList({ companyPage, setCompanyPage }) {
    const dispatch = useDispatch();
    const loadingRef = useRef(false);
    const [deleteClick, setDelteClick] = useState(false)
    const [form] = Form.useForm();
    const [edit, setEdit] = useState(true)
    const [display, setDisplay] = useState()
    const [disable, setDisable] = useState(false)
    const [displayDatas, setdisplayDatas] = useState()
    const [companyName, setCompanyName] = useState()
    const [companyCode, setCompanyCode] = useState()
    const [salesCycle, setSalesCycle] = useState()
    const [industry, setIndustry] = useState()
    const [companySize, setCompanySize] = useState()
    const [financialYear, setFinancialYear] = useState()
    const [city, setCity] = useState("")
    const [allCity, setAllCity] = useState([])
    const [state, setState] = useState("")
    const [allState, setAllState] = useState([])
    const [allTimeZone, setAllTimeZone] = useState([])
    const [country, setCountry] = useState("")
    const [allCountry, setAllCountry] = useState([])
    const [comId, setComId] = useState()
    const [timeZones, setTimeZone] = useState()
    const [previousMonth, setPreviousYear] = useState()

    const normalizeValue = (value) => {
        if (value == null) return null;
        const trimmed = value?.trim?.();
        if (trimmed === "") return null;
        return trimmed ?? value;
    };
    const getCity = async (Address, isoCode) => {
        try {
            const response = await getCityData(isoCode)
            setAllCity(response);
            if (Address.city) {
                setdisplayDatas(Address)
                setDisplay("Details")
                form.setFieldsValue({
                    city: Address.city
                })
                setCity(Address.city)
            }
            else {
                setdisplayDatas(Address)
                setDisplay("Details")
                form.setFieldsValue({
                    city: undefined
                })
            }
        } catch (error) {
            setdisplayDatas(Address)
            setDisplay("Details")
            message.error(error)
        }
    }
    async function getAlltimeZone() {
        try {
            const response = await getTimeZoneData()
            setAllTimeZone(response)
        } catch (error) {
            message.error(error)
        }
    }
    const getState = async (Address, option) => {
        try {
            const response = await getStateData(option)
            setAllState(response);
            if (Address.state) {
                setState(Address.state)
                form.setFieldsValue({
                    state: Address.state,
                    city: undefined
                })
                const stateinfo = response.find(states => states.state === Address.state);
                if (stateinfo) {
                    const iso = stateinfo.stateId
                    getCity(Address, iso)
                }
            }
            else {
                setdisplayDatas(Address)
                setDisplay("Details")
                form.setFieldsValue({
                    state: undefined,
                    city: undefined
                })
            }
        } catch (error) {
            setdisplayDatas(Address)
            setDisplay("Details")
            message.error(error)
        }
    }
    const setCompanyData = async (value) => {
        if (value !== undefined) {
            form.setFieldsValue({
                websites: value.accountUrl,
                month: value.monthName,
                salesMonth: value.salesCycle,
                timeZone: value.timeZone,
                street: value.street,
                postcode: (value.zipcode === "0" || value.zipcode === 0) ? null : value.zipcode,
            })
            setTimeZone(value.timeZone)
            setSalesCycle(value.salesCycle)
            setCompanyName(value.companyName)
            setIndustry(value.industry)
            setCompanySize(value.companySize)
            setFinancialYear(value.monthName)
            setPreviousYear(value.monthName)
            setComId(value.companyId)
            setCountry(value.country)
            setCompanyCode(value.companyCode)
            try {
                const response = await getCountryData()
                if (value.country && value.country !== "") {
                    form.setFieldsValue({
                        country: value.country,
                        state: undefined,
                        city: undefined
                    })
                    const countryInfo = response.find(countrys => countrys.country === value.country);
                    if (countryInfo) {
                        const iso = countryInfo.countryId
                        getState(value, iso)
                    }
                } else {
                    setdisplayDatas(value)
                    setDisplay("Details")
                }
            } catch (error) {
                setdisplayDatas(value)
                setDisplay("Details")
                message.error(error)
            }
        }
    }
    async function companyDetailsApi2() {
        try {
            const CompanyDetails = await getCompanyByUser()
            dispatch(setUserData({
                company: CompanyDetails
            }));
            setCompanyPage(false)
        }
        catch (error) {
            message.error(error)
        }
    }
    async function companyDetailsApi() {
        try {
            setDisplay()
            const data = await getCompanyByUser()
            setCompanyData(data)
        }
        catch (error) {
            message.error(error)
        }
    }
    const handleMonthChange = (value) => {
        setFinancialYear(value)
    }
    const getCountry = async () => {
        try {
            const response = await getCountryData()
            setAllCountry(response)
        }
        catch (error) {
            message.error(error)
        }
    }
    const handleCountryChange = async (value, option) => {
        setCountry(value);
        if (option.key) {
            try {
                const response = await getStateData(option.key)
                setAllState(response);
                setState()
                setCity()
                setAllCity([])
                form.setFieldsValue({
                    state: undefined,
                    city: undefined
                })
            } catch (error) {
                message.error(error)
            }
        } else {
            setAllState([]);
            setAllCity([])
            setState()
            setCity()
            form.setFieldsValue({
                state: undefined,
                city: undefined
            })
        }
    }
    const handleStateChange = async (value, option) => {
        setState(value);
        if (option.key) {
            try {
                const response = await getCityData(option.key)
                setAllCity(response);
                setCity()
                form.setFieldsValue({
                    city: undefined
                })
            } catch (error) {
                message.error(error)
            }
        }
        else {
            setAllCity([]);
            setCity()
            form.setFieldsValue({
                city: undefined
            })
        }
    }
    const handleCityChange = (value) => {
        setCity(value)
    }
    async function ProfileDetails() {
        try {
            const response = await getByUserProfile()
            if (response) {
                dispatch(setUserData({ profile: response }));
            }
        } catch (error) {
            message.error(error)
        }
    }
    async function userUpdate(params, country) {
        const payload = {
            timeZone: params,
            country
        }

        await updateUserProfile(payload)
            .catch(err => {
                console.error("updateUserProfile failed", err);
            })
        ProfileDetails()

    }
    useEffect(() => {
        if (companyPage) {
            const fetchAll = async () => {
                await Promise.allSettled([
                    getAlltimeZone(),
                    companyDetailsApi(),
                    getCountry()
                ])
            };
            fetchAll();
        }
    }, [companyPage])

    const onSubmit = async (value) => {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setDelteClick(true)
        setDisable(true)
        const { timeZone, websites, postcode, street, registeredName, registrationNumber } = value;
        const payload =
        {
            registeredName: normalizeValue(registeredName),
            registrationNumber: normalizeValue(registrationNumber),
            accountUrl: normalizeValue(websites),
            monthName: normalizeValue(financialYear),
            zipcode: normalizeValue(postcode * 1),
            forecastCommitStartDate: "0",
            forecastCommitEndDate: "0",
            state,
            street: normalizeValue(street),
            city,
            country,
            salesCycle: normalizeValue(salesCycle),
            timeZone: (timeZones && timeZones !== "") ? timeZones : timeZone,
            loginSetupStatus: "Company"
        }
        const hideMessage = message.loading("Updating company profile...", 0);
        const response = await CompanyUpdate(payload, comId)
        if (response.data.statusCode === 200) {
            if (previousMonth !== financialYear) {
                // message.info("Updating forecast months, Please, wait")
                const response1 = await forecastCalculation();
                if (response1.length > 0) {
                    hideMessage();
                    setDisable(false)
                    // message.success("Forecast and Company details updated")
                    message.success("Company profile updated")
                    setEdit(false)
                    companyDetailsApi2()
                    companyDetailsApi()
                    userUpdate((timeZones && timeZones !== "") ? timeZones : timeZone, country)
                } else {
                    setDisable(false)
                }
            }
            else {
                hideMessage();
                setDisable(false)
                message.success("Company profile updated")
                setEdit(false)
                companyDetailsApi2()
                companyDetailsApi()
                userUpdate((timeZones && timeZones !== "") ? timeZones : timeZone, country)
            }
            loadingRef.current = false;
            setDelteClick(false)
        } else {
            loadingRef.current = false;
            setDelteClick(false)
            setDisable(false)
        }
    }
    const onFinishFailed = () => {
        message.error("Please fill out all required fields")
    }

    return (
        <>
            <Modal
                open={companyPage}
                width={1200}
                style={{ marginTop: "5%" }}
                centered
                footer={
                    [<div>
                        <Button
                            size="small" disabled={disable || deleteClick} loading={deleteClick}
                            className="button_colors"
                            onClick={() => form.submit()}
                        >
                            {!deleteClick && <FeatherIcon icon="save" />}Save and Next
                        </Button>
                    </div>]}
                closable={false}     // 🔹 removes default top-right close icon
                title="Quick Company Setup"        // 🔹 removes header/title bar
                destroyOnClose
                maskClosable={false} // optional: prevents clicking outside to close
                bodyStyle={{ padding: 40 }}
            >
                {display ?
                    <AddUser>
                        <div className="user-info-form">
                            <BasicFormWrapper>
                                <VerticalFormStyleWrap>
                                    <Form style={{ width: '100%' }} form={form} colon={false} name="company"
                                        // form={form} // single form for both tabs
                                        // layout="vertical"
                                        onFinish={onSubmit} // send combined data to API
                                        onFinishFailed={onFinishFailed}
                                    >
                                        <div className="add-product-block">
                                            <div>
                                                {/* <div style={{ textAlign: "center", margin: "0px 0px 10px" }}><Heading as="h5">Enter Mandatory Information</Heading></div> */}
                                                <Heading as="h5">Company Information</Heading>
                                                <Row gutter={30} style={{ margin: "20px 0px 0px" }}>
                                                    <Col span={8} style={{ marginBottom: 30 }}>
                                                        <Form.Item label="Company Name & Code" >
                                                            <span >{companyName} {companyCode}</span> </Form.Item>
                                                    </Col>
                                                    <Col span={8} style={{ marginBottom: 30 }}>
                                                        <Form.Item
                                                            label="Industry" name="industry"
                                                        > <span >{industry}</span></Form.Item>
                                                    </Col>
                                                    <Col span={8} style={{ marginBottom: 30 }}>
                                                        <Form.Item label="No of Employees" name="nomemployee"
                                                        > <span >{companySize}</span></Form.Item>
                                                    </Col>
                                                    <Col span={8} style={{ marginBottom: 30 }} >
                                                        <Form.Item label="Registered Name" name="registeredName" id="registeredName"
                                                            rules={[{
                                                                required: true,
                                                                transform: (value) => value?.trim(), message: 'Please enter registered Name'
                                                            }, {
                                                                validator: (_, value) => {
                                                                    const error = nameOnChangeValidator(value, 50);
                                                                    if (error) {
                                                                        return Promise.reject(new Error(error));
                                                                    }
                                                                    return Promise.resolve();
                                                                },
                                                            }]}>
                                                            {edit ? <Input placeholder="Enter Registered Name" /> : <span >{displayDatas?.registeredName}</span>}</Form.Item>
                                                    </Col>
                                                    <Col span={8} style={{ marginBottom: 30 }} >
                                                        <Form.Item label="Registration Number" name="registrationNumber" id="registrationNumber"
                                                            rules={[
                                                                //     {
                                                                //     required: true,
                                                                //     transform: (value) => value?.trim(), message: 'Please enter registration number'
                                                                // }, 
                                                                {
                                                                    validator: (_, value) => {
                                                                        const error = regNumOnChangeValidator(value, 25);
                                                                        if (error) {
                                                                            return Promise.reject(new Error(error));
                                                                        }
                                                                        return Promise.resolve();
                                                                    },
                                                                }]}>
                                                            {edit ? <Input placeholder="Enter Registration number" /> : <span >{displayDatas?.registrationNumber}</span>}</Form.Item>
                                                    </Col>
                                                </Row>
                                                <Row gutter={30} style={{ margin: "0px 0px 20px" }}>
                                                    <Col span={12}>
                                                        <Row >
                                                            <Col span={16} style={{ marginBottom: 30 }}>
                                                                <Form.Item label="Website Url" name="websites"
                                                                    rules={[{
                                                                        required: true,
                                                                        transform: (value) => value?.trim(), message: 'Please enter website'
                                                                    }, {
                                                                        validator: (_, value) => {
                                                                            const error = validateUrlField(value, 2000);
                                                                            if (error) {
                                                                                return Promise.reject(new Error(error));
                                                                            }
                                                                            return Promise.resolve();
                                                                        },
                                                                    },]}>
                                                                    <Input placeholder="www.example.com" />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={24}>
                                                                <Form.Item label={<div><span className="required-symbol">* </span>Financial Year Start</div>} >
                                                                    <div className='Form-Text'>Specifies the start of your company’s financial year. This is used to organize revenue and forecasts by quarters for accurate reporting and analysis. <strong>Please note this setting at the company level cannot be changed once saved</strong></div>
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={16} style={{ marginBottom: 30 }}>
                                                                <Form.Item name="month"
                                                                    rules={[{ required: true, message: 'Please select FY start month' }]}>
                                                                    <Select
                                                                        style={{ width: '100%' }}
                                                                        showSearch
                                                                        placeholder="Select Month"
                                                                        optionFilterProp="children"
                                                                        filterOption={(input, option) =>
                                                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                        }
                                                                        onChange={handleMonthChange}
                                                                        value={financialYear}
                                                                    >
                                                                        {DaysJson.Month !== undefined && DaysJson.Month?.map((option) => (
                                                                            <Option key={option.lable} value={option.lable}>
                                                                                {option.lable}
                                                                            </Option>
                                                                        ))}
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={24}>
                                                                <Form.Item label={<div><span className="required-symbol">* </span>Sales Cycle</div>} >
                                                                    <div className='Form-Text'>Defines your company’s typical duration for closing a sale. This is used to apply time-based decay to interaction scores so older activities have less impact over time</div>
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={16} style={{ marginBottom: 30 }}>
                                                                <Form.Item name="salesMonth"
                                                                    rules={[{ required: true, message: 'Please select sales cycle' }]}>
                                                                    <Select
                                                                        style={{ width: '100%' }}
                                                                        showSearch
                                                                        placeholder="Select Sales Cycle"
                                                                        optionFilterProp="children"
                                                                        filterOption={(input, option) =>
                                                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                        }
                                                                        onChange={(value) => setSalesCycle(value)}
                                                                        value={salesCycle}
                                                                    >
                                                                        <Option value="1-3 weeks">1 - 3 weeks</Option>
                                                                        <Option value="3-6 weeks">3 - 6 weeks</Option>
                                                                        <Option value="6-12 weeks">6 - 12 weeks</Option>
                                                                        <Option value=">12 Weeks">&gt; 12 Weeks</Option>
                                                                    </Select>
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={24}>
                                                                <Form.Item label={<div>{(timeZones && timeZones !== "") ? "" : <span className="required-symbol">* </span>}Time Zone</div>} >
                                                                    <div className='Form-Text'>Sets the default timezone for the company. Users can select their own timezone individually. <strong>Please note this setting at the company level cannot be changed once saved</strong></div>
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={16} style={{ marginBottom: 30 }}>
                                                                {(timeZones && timeZones !== "") ?
                                                                    <Form.Item >
                                                                        <span>{timeZones}</span>
                                                                    </Form.Item> :
                                                                    <Form.Item name="timeZone" id="timeZone" rules={[{ required: true, message: 'Please select timezone' }]}>
                                                                        <Select
                                                                            style={{ width: '100%' }}
                                                                            showSearch
                                                                            placeholder="Select Time Zone"
                                                                            optionFilterProp="children"
                                                                            filterOption={(input, option) =>
                                                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                            } >
                                                                            {allTimeZone !== undefined && allTimeZone.map((option, i) => (
                                                                                <Option key={i} value={option.timeZone}>
                                                                                    {option.timeZone}
                                                                                </Option>
                                                                            ))}
                                                                        </Select>
                                                                    </Form.Item>}
                                                            </Col></Row>
                                                    </Col>
                                                    <Col span={12} style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                                                        <div >
                                                            <img src={require("../../../static/img/defaultImages/Onboarding.png")} alt='landingImage' style={{ height: "400px" }} />
                                                        </div>
                                                        {/* <Row>
                                                            <Col
                                                                span={24}
                                                                style={{
                                                                    height: "500px",
                                                                    backgroundImage: `url(${require("../../../static/img/defaultImages/Onboarding.png")})`,
                                                                    backgroundSize: "cover",
                                                                    backgroundPosition: "center",
                                                                }}
                                                            />
                                                        </Row> */}
                                                    </Col>
                                                </Row>
                                                <Heading as="h5">Registered Office Address</Heading>
                                                <Row gutter={30} style={{ margin: "20px 0px 0px" }}>
                                                    <Col span={8} style={{ marginBottom: 30 }}>
                                                        <Form.Item label="Country" name="country" id="country" rules={edit ? [{ message: 'Please select country', required: true }] : [{ required: false }]}>
                                                            {edit ? <Select
                                                                style={{ width: '100%' }}
                                                                showSearch
                                                                placeholder="Select Country"
                                                                optionFilterProp="children"
                                                                filterOption={(input, option) =>
                                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                }
                                                                onChange={handleCountryChange}
                                                                value={country}
                                                            >
                                                                {allCountry?.map((option) => (
                                                                    <Option key={option.countryId} value={option.country}>
                                                                        {option.country}
                                                                    </Option>
                                                                ))}
                                                            </Select> : <span >{displayDatas?.country}</span>}
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span={8} style={{ marginBottom: 30 }}>
                                                        <Form.Item label="State" name="state" id="state"
                                                            rules={edit ? [{ message: 'Please select state', required: true }] : [{ required: false }]}
                                                        >
                                                            {edit ? <Select
                                                                style={{ width: '100%' }}
                                                                showSearch
                                                                placeholder="Select State"
                                                                optionFilterProp="children"
                                                                filterOption={(input, option) =>
                                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                }
                                                                onChange={handleStateChange}
                                                                value={state}
                                                            >
                                                                {allState?.map((option) => (
                                                                    <Option key={option.stateId} value={option.state}>
                                                                        {option.state}
                                                                    </Option>
                                                                ))}
                                                            </Select>
                                                                : <span >{displayDatas?.state}</span>}
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span={8} style={{ marginBottom: 30 }}>
                                                        <Form.Item label="City" name="city" id="city"
                                                            rules={edit ? [{ message: 'Please select city', required: true }] : [{ required: false }]}
                                                        >
                                                            {edit ? <Select
                                                                style={{ width: '100%' }}
                                                                showSearch
                                                                placeholder="Select city"
                                                                optionFilterProp="children"
                                                                filterOption={(input, option) =>
                                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                                }
                                                                onChange={handleCityChange}
                                                                value={city}
                                                            >
                                                                {allCity?.map((option) => (
                                                                    <Option key={option.cityId} value={option.city}>
                                                                        {option.city}
                                                                    </Option>
                                                                ))}
                                                            </Select>
                                                                : <span >{displayDatas?.city}</span>}
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span={8} style={{ marginBottom: 30 }}>
                                                        <Form.Item label="Street name and No" name="street" id="street" rules={[{
                                                            message: 'Please enter street name and No',
                                                            transform: (value) => value?.trim(), required: true
                                                        }, {
                                                            validator: (_, value) => {
                                                                const error = validateAddressLine(value, 100);
                                                                if (error) {
                                                                    return Promise.reject(new Error(error));
                                                                }
                                                                return Promise.resolve();
                                                            },
                                                        }]}>
                                                            {edit ? <Input placeholder="Enter Street name and no" /> : <span >{displayDatas?.street}</span>}
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span={8} style={{ marginBottom: 30 }}>
                                                        <Form.Item label="Zip Code" id="postcode" name="postcode" rules={[{
                                                            validator: (_, value) => {
                                                                const error = validateZipCode(value, 25);
                                                                if (error) {
                                                                    return Promise.reject(new Error(error));
                                                                }
                                                                return Promise.resolve();
                                                            },
                                                        }]}>
                                                            {edit ? <Input placeholder="Enter Zip Code" /> : <span >{(displayDatas?.zipcode === "0" || displayDatas?.zipcode === 0) ? null : displayDatas?.zipcode}</span>}
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </div>
                                    </Form>
                                </VerticalFormStyleWrap >
                            </BasicFormWrapper >
                        </div>
                    </AddUser >
                    :
                    <div className="spin">
                        <Spin />
                    </div>}
            </Modal >
        </>
    );

}
UserList.propTypes = {
    companyPage: PropTypes.bool.isRequired,
    setCompanyPage: PropTypes.func.isRequired,
};
export default UserList;
